var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "0" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.dialogCancle,
            "close-on-click-modal": true,
            title: _vm.title,
            visible: _vm.dialogVisibleCopy,
            top: "5vh",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleCopy = $event
            },
          },
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.dialogCancle,
            title: _vm.title,
            visible: _vm.drawerVisibleCopy,
            direction: "rtl",
            size: "425px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisibleCopy = $event
            },
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }